import React from 'react';
import { IconProps } from '.';

const SvgScreenFull = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M14.5 5.5h4V10H20V4h-5.5v1.5ZM10 5.5V4H4v6h1.5V5.5H10ZM5.5 14H4v6h6v-1.5H5.5V14ZM14.5 18.5V20H20v-6h-1.5v4.5h-4Z'
      />
    </svg>
  );
};

export default SvgScreenFull;
